export const CAMPAIGN_SOURCES = ["instagram", "facebook", "whatsapp", "email", "creator"] as const;
export type CampaignSource = typeof CAMPAIGN_SOURCES[number];
export function campaignLink(path: string, source: CampaignSource, campaign: string, content = ""): string {
  const url = new URL(path, "https://sugartownorganics.com");
  if (url.origin !== "https://sugartownorganics.com" || /track-order|checkout\/return|admin/.test(url.pathname)) throw new Error("Choose a public Sugar Town page, not a private order or staff link.");
  url.searchParams.set("utm_source", source);
  url.searchParams.set("utm_medium", source === "email" ? "email" : source === "creator" ? "influencer" : "social");
  url.searchParams.set("utm_campaign", campaign.trim().slice(0, 100) || "shared_link");
  if (content.trim()) url.searchParams.set("utm_content", content.trim().slice(0, 100));
  return url.href;
}
export function isInternalTraffic(host: string, path: string, medium = ""): boolean {
  return host === "localhost" || host === "127.0.0.1" || host.startsWith("id-preview--") || /^(\/admin|\/platform-admin)/.test(path) || medium === "internal";
}
export function readCampaign(search: string) {
  const p = new URLSearchParams(search);
  return { source: (p.get("utm_source") || "").slice(0,100), medium: (p.get("utm_medium") || "").slice(0,100), campaign: (p.get("utm_campaign") || "").slice(0,100), content: (p.get("utm_content") || "").slice(0,100) };
}